import { styled } from 'styles/stitches.config'

export const Flex = styled('div', {
  '@lg': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
})